import React from 'react';
import { useTranslation } from 'react-i18next';
import type { PreventionAlert } from 'types/preventionAlerts';
import { formatMonthYear } from 'utils';
import { PreventionRow } from './PreventionRow';
import { RowSubtitle } from './DuePreventionsSection.styles';

export const LastPerformedRow: React.FC<{ alert: PreventionAlert; name: string }> = ({
  alert,
  name,
}) => {
  const { t } = useTranslation();

  return (
    <PreventionRow alert={alert} name={name}>
      <RowSubtitle>
        {alert.lastPerformedAt
          ? t(
              [
                `result.preventions.lastPerformed.${alert.key}`,
                'result.preventions.lastPerformed.default',
              ],
              { date: formatMonthYear(alert.lastPerformedAt) }
            )
          : t('result.preventions.lastPerformed.neverDone')}
      </RowSubtitle>
    </PreventionRow>
  );
};
